import * as React from "react"

const SvgComponent = (props) => (
    <svg
        style={{
            width: 24,
            height: 24,
        }}
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="#000"
            d="M15.41 16.58 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.42Z"
        />
    </svg>
)

export default SvgComponent

